(function () {
  function setButtonState(btn, disabled) {
    if (!btn) return;
    btn.classList.toggle('is-disabled', disabled);
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    btn.tabIndex = disabled ? -1 : 0;
  }

  function getEdgeSlideIndex(swiper, edge) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return -1;

    var containerRect = swiper.el.getBoundingClientRect();
    var found = -1;

    for (var i = 0; i < swiper.slides.length; i++) {
      var slideRect = swiper.slides[i].getBoundingClientRect();
      var isVisible = slideRect.right > containerRect.left + 1 && slideRect.left < containerRect.right - 1;

      if (!isVisible) continue;

      if (edge === 'start') {
        if (found === -1) found = i;
      } else {
        found = i;
      }
    }

    return found;
  }

  function updateNavState(swiper, prevButtons, nextButtons) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return;

    var lastIndex = swiper.slides.length - 1;
    var leftmost = getEdgeSlideIndex(swiper, 'start');
    var rightmost = getEdgeSlideIndex(swiper, 'end');
    var atStart = leftmost <= 0;
    var atEnd = rightmost >= lastIndex;

    if (swiper.isLocked) {
      atStart = true;
      atEnd = true;
    }

    prevButtons.forEach(function (btn) {
      setButtonState(btn, atStart);
    });
    nextButtons.forEach(function (btn) {
      setButtonState(btn, atEnd);
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.reviewInit === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var swiperEl = sectionEl.querySelector('.openear-review-swiper');
    if (!swiperEl) return;

    sectionEl.dataset.reviewInit = 'true';

    var prevButtons = sectionEl.querySelectorAll('.prev-btn');
    var nextButtons = sectionEl.querySelectorAll('.next-btn');
    var paginationEl = sectionEl.querySelector('.pagination');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 40,
      slidesPerGroup: 2,
      loop: false,
      speed: 450,
      allowTouchMove: true,
      watchOverflow: true,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1
        }
      },
      on: {
        init: function () {
          var self = this;
          updateNavState(self, prevButtons, nextButtons);
          requestAnimationFrame(function () {
            updateNavState(self, prevButtons, nextButtons);
          });
        },
        slideChange: function () {
          updateNavState(this, prevButtons, nextButtons);
        },
        slideChangeTransitionEnd: function () {
          updateNavState(this, prevButtons, nextButtons);
        },
        resize: function () {
          updateNavState(this, prevButtons, nextButtons);
        },
        breakpoint: function () {
          updateNavState(this, prevButtons, nextButtons);
        },
        setTranslate: function () {
          updateNavState(this, prevButtons, nextButtons);
        },
        transitionEnd: function () {
          updateNavState(this, prevButtons, nextButtons);
        },
        touchEnd: function () {
          updateNavState(this, prevButtons, nextButtons);
        }
      }
    });

    prevButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-disabled')) return;
        swiper.slidePrev();
      });
    });

    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-disabled')) return;
        swiper.slideNext();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.section-openear-review').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-openear-review');
    if (section) initSection(section);
  });
})();
